import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  currentPlanKey,
  updateSubscriptionRoute,
  paymentDetails,
  totalAggregateKey,
} from '@features/payments';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';
import { companiesPlansList } from '@features/applications';

type useUpdatePlanProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

export const useUpdatePlan = ({
  setErrorText = () => {},
  onSuccess = () => {},
}: useUpdatePlanProps) => {
  const client = useQueryClient();

  const { mutate: updatePaymentPlan, isLoading: isUpdatingPaymentPlan } =
    useMutation({
      mutationFn: (variables: {
        billing_cycle?: number;
        monthly_trial?:string | null;
        token?: string;
        plan_ids: {
          company_id?: number;
          plan_id?: number;
          new_plan_id: number;
        }[];
        switch?: boolean;
        downgrade_plan?: boolean;
        upgrade_plan?: boolean;
      }) =>
        axiosInstance
          .post(updateSubscriptionRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status === 400) {
          client.invalidateQueries([profileKey]);
        }
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          onSuccess();

          client.invalidateQueries([currentPlanKey]);
          client.invalidateQueries([paymentDetails]);
          client.invalidateQueries([profileKey]);
          client.invalidateQueries([totalAggregateKey]);
          client.invalidateQueries([companiesPlansList]);
        }
      },
      onError: () => setErrorText(errorMessage),
    });

  return {
    updatePaymentPlan,
    isUpdatingPaymentPlan,
  };
};
